import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/esnext.string.replace-all.js";
import React from 'react';
import ReactDOM from 'react-dom';
function ICompress() {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-rmiz-btn-unzoom-icon": true,
    fill: "currentColor",
    focusable: "false",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M 14.144531 1.148438 L 9 6.292969 L 9 3 L 8 3 L 8 8 L 13 8 L 13 7 L 9.707031 7 L 14.855469 1.851563 Z M 8 8 L 3 8 L 3 9 L 6.292969 9 L 1.148438 14.144531 L 1.851563 14.855469 L 7 9.707031 L 7 13 L 8 13 Z"
  }));
}
function IEnlarge() {
  return React.createElement("svg", {
    "aria-hidden": "true",
    "data-rmiz-btn-zoom-icon": true,
    fill: "currentColor",
    focusable: "false",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M 9 1 L 9 2 L 12.292969 2 L 2 12.292969 L 2 9 L 1 9 L 1 14 L 6 14 L 6 13 L 2.707031 13 L 13 2.707031 L 13 6 L 14 6 L 14 1 Z"
  }));
}
var testElType = function testElType(type, el) {
  var _el$tagName, _el$tagName$toUpperCa;
  return type === (el === null || el === void 0 || (_el$tagName = el.tagName) === null || _el$tagName === void 0 || (_el$tagName$toUpperCa = _el$tagName.toUpperCase) === null || _el$tagName$toUpperCa === void 0 ? void 0 : _el$tagName$toUpperCa.call(_el$tagName));
};
var testDiv = function testDiv(el) {
  return testElType('DIV', el) || testElType('SPAN', el);
};
var testImg = function testImg(el) {
  return testElType('IMG', el);
};
var testImgLoaded = function testImgLoaded(el) {
  return el.complete && el.naturalHeight !== 0;
};
var testSvg = function testSvg(el) {
  return testElType('SVG', el);
};
var getScaleToWindow = function getScaleToWindow(_ref) {
  var height = _ref.height,
    offset = _ref.offset,
    width = _ref.width;
  return Math.min((window.innerWidth - offset * 2) / width, (window.innerHeight - offset * 2) / height);
};
var getScaleToWindowMax = function getScaleToWindowMax(_ref2) {
  var containerHeight = _ref2.containerHeight,
    containerWidth = _ref2.containerWidth,
    offset = _ref2.offset,
    targetHeight = _ref2.targetHeight,
    targetWidth = _ref2.targetWidth;
  var scale = getScaleToWindow({
    height: targetHeight,
    offset: offset,
    width: targetWidth
  });
  var ratio = targetWidth > targetHeight ? targetWidth / containerWidth : targetHeight / containerHeight;
  return scale > 1 ? ratio : scale * ratio;
};
var getScale = function getScale(_ref3) {
  var containerHeight = _ref3.containerHeight,
    containerWidth = _ref3.containerWidth,
    hasScalableSrc = _ref3.hasScalableSrc,
    offset = _ref3.offset,
    targetHeight = _ref3.targetHeight,
    targetWidth = _ref3.targetWidth;
  if (!containerHeight || !containerWidth) {
    return 1;
  }
  return !hasScalableSrc && targetHeight && targetWidth ? getScaleToWindowMax({
    containerHeight: containerHeight,
    containerWidth: containerWidth,
    offset: offset,
    targetHeight: targetHeight,
    targetWidth: targetWidth
  }) : getScaleToWindow({
    height: containerHeight,
    offset: offset,
    width: containerWidth
  });
};
var URL_REGEX = /url(?:\(['"]?)(.*?)(?:['"]?\))/;
var getImgSrc = function getImgSrc(imgEl) {
  if (imgEl) {
    if (testImg(imgEl)) {
      return imgEl.currentSrc;
    } else if (testDiv(imgEl)) {
      var bgImg = window.getComputedStyle(imgEl).backgroundImage;
      if (bgImg) {
        var _URL_REGEX$exec;
        return (_URL_REGEX$exec = URL_REGEX.exec(bgImg)) === null || _URL_REGEX$exec === void 0 ? void 0 : _URL_REGEX$exec[1];
      }
    }
  }
};
var getImgAlt = function getImgAlt(imgEl) {
  if (imgEl) {
    if (testImg(imgEl)) {
      var _imgEl$alt;
      return (_imgEl$alt = imgEl.alt) !== null && _imgEl$alt !== void 0 ? _imgEl$alt : undefined;
    } else {
      var _imgEl$getAttribute;
      return (_imgEl$getAttribute = imgEl.getAttribute('aria-label')) !== null && _imgEl$getAttribute !== void 0 ? _imgEl$getAttribute : undefined;
    }
  }
};
var getImgRegularStyle = function getImgRegularStyle(_ref4) {
  var containerHeight = _ref4.containerHeight,
    containerLeft = _ref4.containerLeft,
    containerTop = _ref4.containerTop,
    containerWidth = _ref4.containerWidth,
    hasScalableSrc = _ref4.hasScalableSrc,
    offset = _ref4.offset,
    targetHeight = _ref4.targetHeight,
    targetWidth = _ref4.targetWidth;
  var scale = getScale({
    containerHeight: containerHeight,
    containerWidth: containerWidth,
    hasScalableSrc: hasScalableSrc,
    offset: offset,
    targetHeight: targetHeight,
    targetWidth: targetWidth
  });
  return {
    top: containerTop,
    left: containerLeft,
    width: containerWidth * scale,
    height: containerHeight * scale,
    transform: "translate(0,0) scale(".concat(1 / scale, ")")
  };
};
var parsePosition = function parsePosition(_ref5) {
  var position = _ref5.position,
    relativeNum = _ref5.relativeNum;
  var positionNum = parseFloat(position);
  return position.endsWith('%') ? relativeNum * positionNum / 100 : positionNum;
};
var getImgObjectFitStyle = function getImgObjectFitStyle(_ref6) {
  var containerHeight = _ref6.containerHeight,
    containerLeft = _ref6.containerLeft,
    containerTop = _ref6.containerTop,
    containerWidth = _ref6.containerWidth,
    hasScalableSrc = _ref6.hasScalableSrc,
    objectFit = _ref6.objectFit,
    objectPosition = _ref6.objectPosition,
    offset = _ref6.offset,
    targetHeight = _ref6.targetHeight,
    targetWidth = _ref6.targetWidth;
  if (objectFit === 'scale-down') {
    if (targetWidth <= containerWidth && targetHeight <= containerHeight) {
      objectFit = 'none';
    } else {
      objectFit = 'contain';
    }
  }
  if (objectFit === 'cover' || objectFit === 'contain') {
    var widthRatio = containerWidth / targetWidth;
    var heightRatio = containerHeight / targetHeight;
    var ratio = objectFit === 'cover' ? Math.max(widthRatio, heightRatio) : Math.min(widthRatio, heightRatio);
    var _objectPosition$split = objectPosition.split(' '),
      _objectPosition$split2 = _slicedToArray(_objectPosition$split, 2),
      _objectPosition$split3 = _objectPosition$split2[0],
      posLeft = _objectPosition$split3 === void 0 ? '50%' : _objectPosition$split3,
      _objectPosition$split4 = _objectPosition$split2[1],
      posTop = _objectPosition$split4 === void 0 ? '50%' : _objectPosition$split4;
    var posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth * ratio
    });
    var posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight * ratio
    });
    var scale = getScale({
      containerHeight: targetHeight * ratio,
      containerWidth: targetWidth * ratio,
      hasScalableSrc: hasScalableSrc,
      offset: offset,
      targetHeight: targetHeight,
      targetWidth: targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * ratio * scale,
      height: targetHeight * ratio * scale,
      transform: "translate(0,0) scale(".concat(1 / scale, ")")
    };
  } else if (objectFit === 'none') {
    var _objectPosition$split5 = objectPosition.split(' '),
      _objectPosition$split6 = _slicedToArray(_objectPosition$split5, 2),
      _objectPosition$split7 = _objectPosition$split6[0],
      _posLeft = _objectPosition$split7 === void 0 ? '50%' : _objectPosition$split7,
      _objectPosition$split8 = _objectPosition$split6[1],
      _posTop = _objectPosition$split8 === void 0 ? '50%' : _objectPosition$split8;
    var _posX = parsePosition({
      position: _posLeft,
      relativeNum: containerWidth - targetWidth
    });
    var _posY = parsePosition({
      position: _posTop,
      relativeNum: containerHeight - targetHeight
    });
    var _scale = getScale({
      containerHeight: targetHeight,
      containerWidth: targetWidth,
      hasScalableSrc: hasScalableSrc,
      offset: offset,
      targetHeight: targetHeight,
      targetWidth: targetWidth
    });
    return {
      top: containerTop + _posY,
      left: containerLeft + _posX,
      width: targetWidth * _scale,
      height: targetHeight * _scale,
      transform: "translate(0,0) scale(".concat(1 / _scale, ")")
    };
  } else if (objectFit === 'fill') {
    var _widthRatio = containerWidth / targetWidth;
    var _heightRatio = containerHeight / targetHeight;
    var _ratio = Math.max(_widthRatio, _heightRatio);
    var _scale2 = getScale({
      containerHeight: targetHeight * _ratio,
      containerWidth: targetWidth * _ratio,
      hasScalableSrc: hasScalableSrc,
      offset: offset,
      targetHeight: targetHeight,
      targetWidth: targetWidth
    });
    return {
      width: containerWidth * _scale2,
      height: containerHeight * _scale2,
      transform: "translate(0,0) scale(".concat(1 / _scale2, ")")
    };
  } else {
    return {};
  }
};
var getDivImgStyle = function getDivImgStyle(_ref7) {
  var backgroundPosition = _ref7.backgroundPosition,
    backgroundSize = _ref7.backgroundSize,
    containerHeight = _ref7.containerHeight,
    containerLeft = _ref7.containerLeft,
    containerTop = _ref7.containerTop,
    containerWidth = _ref7.containerWidth,
    hasScalableSrc = _ref7.hasScalableSrc,
    offset = _ref7.offset,
    targetHeight = _ref7.targetHeight,
    targetWidth = _ref7.targetWidth;
  if (backgroundSize === 'cover' || backgroundSize === 'contain') {
    var widthRatio = containerWidth / targetWidth;
    var heightRatio = containerHeight / targetHeight;
    var ratio = backgroundSize === 'cover' ? Math.max(widthRatio, heightRatio) : Math.min(widthRatio, heightRatio);
    var _backgroundPosition$s = backgroundPosition.split(' '),
      _backgroundPosition$s2 = _slicedToArray(_backgroundPosition$s, 2),
      _backgroundPosition$s3 = _backgroundPosition$s2[0],
      posLeft = _backgroundPosition$s3 === void 0 ? '50%' : _backgroundPosition$s3,
      _backgroundPosition$s4 = _backgroundPosition$s2[1],
      posTop = _backgroundPosition$s4 === void 0 ? '50%' : _backgroundPosition$s4;
    var posX = parsePosition({
      position: posLeft,
      relativeNum: containerWidth - targetWidth * ratio
    });
    var posY = parsePosition({
      position: posTop,
      relativeNum: containerHeight - targetHeight * ratio
    });
    var scale = getScale({
      containerHeight: targetHeight * ratio,
      containerWidth: targetWidth * ratio,
      hasScalableSrc: hasScalableSrc,
      offset: offset,
      targetHeight: targetHeight,
      targetWidth: targetWidth
    });
    return {
      top: containerTop + posY,
      left: containerLeft + posX,
      width: targetWidth * ratio * scale,
      height: targetHeight * ratio * scale,
      transform: "translate(0,0) scale(".concat(1 / scale, ")")
    };
  } else if (backgroundSize === 'auto') {
    var _backgroundPosition$s5 = backgroundPosition.split(' '),
      _backgroundPosition$s6 = _slicedToArray(_backgroundPosition$s5, 2),
      _backgroundPosition$s7 = _backgroundPosition$s6[0],
      _posLeft2 = _backgroundPosition$s7 === void 0 ? '50%' : _backgroundPosition$s7,
      _backgroundPosition$s8 = _backgroundPosition$s6[1],
      _posTop2 = _backgroundPosition$s8 === void 0 ? '50%' : _backgroundPosition$s8;
    var _posX2 = parsePosition({
      position: _posLeft2,
      relativeNum: containerWidth - targetWidth
    });
    var _posY2 = parsePosition({
      position: _posTop2,
      relativeNum: containerHeight - targetHeight
    });
    var _scale3 = getScale({
      containerHeight: targetHeight,
      containerWidth: targetWidth,
      hasScalableSrc: hasScalableSrc,
      offset: offset,
      targetHeight: targetHeight,
      targetWidth: targetWidth
    });
    return {
      top: containerTop + _posY2,
      left: containerLeft + _posX2,
      width: targetWidth * _scale3,
      height: targetHeight * _scale3,
      transform: "translate(0,0) scale(".concat(1 / _scale3, ")")
    };
  } else {
    var _backgroundSize$split = backgroundSize.split(' '),
      _backgroundSize$split2 = _slicedToArray(_backgroundSize$split, 2),
      _backgroundSize$split3 = _backgroundSize$split2[0],
      sizeW = _backgroundSize$split3 === void 0 ? '50%' : _backgroundSize$split3,
      _backgroundSize$split4 = _backgroundSize$split2[1],
      sizeH = _backgroundSize$split4 === void 0 ? '50%' : _backgroundSize$split4;
    var sizeWidth = parsePosition({
      position: sizeW,
      relativeNum: containerWidth
    });
    var sizeHeight = parsePosition({
      position: sizeH,
      relativeNum: containerHeight
    });
    var _widthRatio2 = sizeWidth / targetWidth;
    var _heightRatio2 = sizeHeight / targetHeight;
    var _ratio2 = Math.min(_widthRatio2, _heightRatio2);
    var _backgroundPosition$s9 = backgroundPosition.split(' '),
      _backgroundPosition$s10 = _slicedToArray(_backgroundPosition$s9, 2),
      _backgroundPosition$s11 = _backgroundPosition$s10[0],
      _posLeft3 = _backgroundPosition$s11 === void 0 ? '50%' : _backgroundPosition$s11,
      _backgroundPosition$s12 = _backgroundPosition$s10[1],
      _posTop3 = _backgroundPosition$s12 === void 0 ? '50%' : _backgroundPosition$s12;
    var _posX3 = parsePosition({
      position: _posLeft3,
      relativeNum: containerWidth - targetWidth * _ratio2
    });
    var _posY3 = parsePosition({
      position: _posTop3,
      relativeNum: containerHeight - targetHeight * _ratio2
    });
    var _scale4 = getScale({
      containerHeight: targetHeight * _ratio2,
      containerWidth: targetWidth * _ratio2,
      hasScalableSrc: hasScalableSrc,
      offset: offset,
      targetHeight: targetHeight,
      targetWidth: targetWidth
    });
    return {
      top: containerTop + _posY3,
      left: containerLeft + _posX3,
      width: targetWidth * _ratio2 * _scale4,
      height: targetHeight * _ratio2 * _scale4,
      transform: "translate(0,0) scale(".concat(1 / _scale4, ")")
    };
  }
};
var SRC_SVG_REGEX = /\.svg$/i;
var getStyleModalImg = function getStyleModalImg(_ref8) {
  var _imgSrc$slice;
  var hasZoomImg = _ref8.hasZoomImg,
    imgSrc = _ref8.imgSrc,
    isSvg = _ref8.isSvg,
    isZoomed = _ref8.isZoomed,
    loadedImgEl = _ref8.loadedImgEl,
    offset = _ref8.offset,
    shouldRefresh = _ref8.shouldRefresh,
    targetEl = _ref8.targetEl;
  var hasScalableSrc = isSvg || (imgSrc === null || imgSrc === void 0 || (_imgSrc$slice = imgSrc.slice) === null || _imgSrc$slice === void 0 ? void 0 : _imgSrc$slice.call(imgSrc, 0, 18)) === 'data:image/svg+xml' || hasZoomImg || !!(imgSrc && SRC_SVG_REGEX.test(imgSrc));
  var imgRect = targetEl.getBoundingClientRect();
  var targetElComputedStyle = window.getComputedStyle(targetEl);
  var isDivImg = loadedImgEl != null && testDiv(targetEl);
  var isImgObjectFit = loadedImgEl != null && !isDivImg;
  var styleImgRegular = getImgRegularStyle({
    containerHeight: imgRect.height,
    containerLeft: imgRect.left,
    containerTop: imgRect.top,
    containerWidth: imgRect.width,
    hasScalableSrc: hasScalableSrc,
    offset: offset,
    targetHeight: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalHeight) || imgRect.height,
    targetWidth: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalWidth) || imgRect.width
  });
  var styleImgObjectFit = isImgObjectFit ? getImgObjectFitStyle({
    containerHeight: imgRect.height,
    containerLeft: imgRect.left,
    containerTop: imgRect.top,
    containerWidth: imgRect.width,
    hasScalableSrc: hasScalableSrc,
    objectFit: targetElComputedStyle.objectFit,
    objectPosition: targetElComputedStyle.objectPosition,
    offset: offset,
    targetHeight: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalHeight) || imgRect.height,
    targetWidth: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalWidth) || imgRect.width
  }) : undefined;
  var styleDivImg = isDivImg ? getDivImgStyle({
    backgroundPosition: targetElComputedStyle.backgroundPosition,
    backgroundSize: targetElComputedStyle.backgroundSize,
    containerHeight: imgRect.height,
    containerLeft: imgRect.left,
    containerTop: imgRect.top,
    containerWidth: imgRect.width,
    hasScalableSrc: hasScalableSrc,
    offset: offset,
    targetHeight: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalHeight) || imgRect.height,
    targetWidth: (loadedImgEl === null || loadedImgEl === void 0 ? void 0 : loadedImgEl.naturalWidth) || imgRect.width
  }) : undefined;
  var style = Object.assign({}, styleImgRegular, styleImgObjectFit, styleDivImg);
  if (isZoomed) {
    var viewportX = window.innerWidth / 2;
    var viewportY = window.innerHeight / 2;
    var childCenterX = parseFloat(String(style.left || 0)) + parseFloat(String(style.width || 0)) / 2;
    var childCenterY = parseFloat(String(style.top || 0)) + parseFloat(String(style.height || 0)) / 2;
    var translateX = viewportX - childCenterX;
    var translateY = viewportY - childCenterY;
    if (shouldRefresh) {
      style.transitionDuration = '0.01ms';
    }
    style.transform = "translate(".concat(translateX, "px,").concat(translateY, "px) scale(1)");
  }
  return style;
};
var getStyleGhost = function getStyleGhost(imgEl) {
  if (!imgEl) {
    return {};
  }
  if (testSvg(imgEl)) {
    var parentEl = imgEl.parentElement;
    var rect = imgEl.getBoundingClientRect();
    if (parentEl) {
      var parentRect = parentEl.getBoundingClientRect();
      return {
        height: rect.height,
        left: parentRect.left - rect.left,
        top: parentRect.top - rect.top,
        width: rect.width
      };
    } else {
      return {
        height: rect.height,
        left: rect.left,
        width: rect.width,
        top: rect.top
      };
    }
  } else {
    return {
      height: imgEl.offsetHeight,
      left: imgEl.offsetLeft,
      width: imgEl.offsetWidth,
      top: imgEl.offsetTop
    };
  }
};
var adjustSvgIDs = function adjustSvgIDs(svgEl) {
  var newIdSuffix = '-zoom';
  var attrs = ['clip-path', 'fill', 'mask', 'marker-start', 'marker-mid', 'marker-end'];
  var idMap = new Map();
  if (svgEl.hasAttribute('id')) {
    var oldId = svgEl.id;
    var newId = oldId + newIdSuffix;
    idMap.set(oldId, newId);
    svgEl.id = newId;
  }
  svgEl.querySelectorAll('[id]').forEach(function (el) {
    var oldId = el.id;
    var newId = oldId + newIdSuffix;
    idMap.set(oldId, newId);
    el.id = newId;
  });
  idMap.forEach(function (newId, oldId) {
    var urlOldID = "url(#".concat(oldId, ")");
    var urlNewID = "url(#".concat(newId, ")");
    var attrsQuery = attrs.map(function (attr) {
      return "[".concat(attr, "=\"").concat(urlOldID, "\"]");
    }).join(', ');
    svgEl.querySelectorAll(attrsQuery).forEach(function (usedEl) {
      attrs.forEach(function (attr) {
        if (usedEl.getAttribute(attr) === urlOldID) {
          usedEl.setAttribute(attr, urlNewID);
        }
      });
    });
  });
  svgEl.querySelectorAll('style').forEach(function (styleEl) {
    idMap.forEach(function (newId, oldId) {
      if (styleEl.textContent) {
        styleEl.textContent = styleEl.textContent.replaceAll("#".concat(oldId), "#".concat(newId));
      }
    });
  });
};
var IMAGE_QUERY = ['img', 'svg', '[role="img"]', '[data-zoom]'].map(function (x) {
  return "".concat(x, ":not([aria-hidden=\"true\"])");
}).join(',');
var defaultBodyAttrs = {
  overflow: '',
  width: ''
};
function Controlled(props) {
  return React.createElement(ControlledBase, _objectSpread({}, props));
}
var ControlledBase = /*#__PURE__*/function (_React$Component) {
  function ControlledBase() {
    var _this;
    _classCallCheck(this, ControlledBase);
    _this = _callSuper(this, ControlledBase, arguments);
    _this.state = {
      id: '',
      isZoomImgLoaded: false,
      loadedImgEl: undefined,
      modalState: "UNLOADED",
      shouldRefresh: false
    };
    _this.refContent = React.createRef();
    _this.refDialog = React.createRef();
    _this.refModalContent = React.createRef();
    _this.refModalImg = React.createRef();
    _this.refWrap = React.createRef();
    _this.imgEl = null;
    _this.isScaling = false;
    _this.prevBodyAttrs = defaultBodyAttrs;
    _this.styleModalImg = {};
    _this.getDialogContainer = function () {
      var el = document.querySelector('[data-rmiz-portal]');
      if (el == null) {
        el = document.createElement('div');
        el.setAttribute('data-rmiz-portal', '');
        document.body.appendChild(el);
      }
      return el;
    };
    _this.setId = function () {
      var gen4 = function gen4() {
        return Math.random().toString(16).slice(-4);
      };
      _this.setState({
        id: gen4() + gen4() + gen4()
      });
    };
    _this.setAndTrackImg = function () {
      var contentEl = _this.refContent.current;
      if (!contentEl) return;
      _this.imgEl = contentEl.querySelector(IMAGE_QUERY);
      if (_this.imgEl) {
        var _this$changeObserver, _this$changeObserver$, _this$imgEl, _this$imgEl$addEventL, _this$imgEl2, _this$imgEl2$addEvent;
        (_this$changeObserver = _this.changeObserver) === null || _this$changeObserver === void 0 || (_this$changeObserver$ = _this$changeObserver.disconnect) === null || _this$changeObserver$ === void 0 || _this$changeObserver$.call(_this$changeObserver);
        (_this$imgEl = _this.imgEl) === null || _this$imgEl === void 0 || (_this$imgEl$addEventL = _this$imgEl.addEventListener) === null || _this$imgEl$addEventL === void 0 || _this$imgEl$addEventL.call(_this$imgEl, 'load', _this.handleImgLoad);
        (_this$imgEl2 = _this.imgEl) === null || _this$imgEl2 === void 0 || (_this$imgEl2$addEvent = _this$imgEl2.addEventListener) === null || _this$imgEl2$addEvent === void 0 || _this$imgEl2$addEvent.call(_this$imgEl2, 'click', _this.handleZoom);
        if (!_this.state.loadedImgEl) {
          _this.handleImgLoad();
        }
        _this.imgElObserver = new ResizeObserver(function (entries) {
          var entry = entries[0];
          if (entry !== null && entry !== void 0 && entry.target) {
            _this.imgEl = entry.target;
            _this.setState({});
          }
        });
        _this.imgElObserver.observe(_this.imgEl);
      } else if (!_this.changeObserver) {
        _this.changeObserver = new MutationObserver(_this.setAndTrackImg);
        _this.changeObserver.observe(contentEl, {
          childList: true,
          subtree: true
        });
      }
    };
    _this.handleIfZoomChanged = function (prevIsZoomed) {
      var isZoomed = _this.props.isZoomed;
      if (!prevIsZoomed && isZoomed) {
        _this.zoom();
      } else if (prevIsZoomed && !isZoomed) {
        _this.unzoom();
      }
    };
    _this.handleImgLoad = function () {
      var _this2 = _this,
        imgEl = _this2.imgEl;
      var imgSrc = getImgSrc(imgEl);
      if (!imgSrc) return;
      var img = new Image();
      if (testImg(imgEl)) {
        img.sizes = imgEl.sizes;
        img.srcset = imgEl.srcset;
      }
      img.src = imgSrc;
      var setLoaded = function setLoaded() {
        _this.setState({
          loadedImgEl: img
        });
      };
      img.decode().then(setLoaded).catch(function () {
        if (testImgLoaded(img)) {
          setLoaded();
          return;
        }
        img.onload = setLoaded;
      });
    };
    _this.handleZoom = function () {
      if (_this.hasImage()) {
        var _this$props$onZoomCha, _this$props;
        (_this$props$onZoomCha = (_this$props = _this.props).onZoomChange) === null || _this$props$onZoomCha === void 0 || _this$props$onZoomCha.call(_this$props, true);
      }
    };
    _this.handleUnzoom = function () {
      var _this$props$onZoomCha2, _this$props2;
      (_this$props$onZoomCha2 = (_this$props2 = _this.props).onZoomChange) === null || _this$props$onZoomCha2 === void 0 || _this$props$onZoomCha2.call(_this$props2, false);
    };
    _this.handleDialogCancel = function (e) {
      e.preventDefault();
    };
    _this.handleDialogClick = function (e) {
      if (e.target === _this.refModalContent.current || e.target === _this.refModalImg.current) {
        _this.handleUnzoom();
      }
    };
    _this.handleKeyDown = function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        _this.handleUnzoom();
      }
    };
    _this.handleWheel = function (e) {
      if (e.ctrlKey) return;
      e.stopPropagation();
      queueMicrotask(function () {
        _this.handleUnzoom();
      });
    };
    _this.handleTouchStart = function (e) {
      if (e.touches.length > 1) {
        _this.isScaling = true;
        return;
      }
      if (e.changedTouches.length === 1 && e.changedTouches[0]) {
        _this.touchYStart = e.changedTouches[0].screenY;
      }
    };
    _this.handleTouchMove = function (e) {
      var _window$visualViewpor, _window$visualViewpor2;
      var browserScale = (_window$visualViewpor = (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 ? void 0 : _window$visualViewpor2.scale) !== null && _window$visualViewpor !== void 0 ? _window$visualViewpor : 1;
      if (_this.props.canSwipeToUnzoom && !_this.isScaling && browserScale <= 1 && _this.touchYStart != null && e.changedTouches[0]) {
        _this.touchYEnd = e.changedTouches[0].screenY;
        var max = Math.max(_this.touchYStart, _this.touchYEnd);
        var min = Math.min(_this.touchYStart, _this.touchYEnd);
        var delta = Math.abs(max - min);
        if (delta > _this.props.swipeToUnzoomThreshold) {
          _this.touchYStart = undefined;
          _this.touchYEnd = undefined;
          _this.handleUnzoom();
        }
      }
    };
    _this.handleTouchEnd = function () {
      _this.isScaling = false;
      _this.touchYStart = undefined;
      _this.touchYEnd = undefined;
    };
    _this.handleTouchCancel = function () {
      _this.isScaling = false;
      _this.touchYStart = undefined;
      _this.touchYEnd = undefined;
    };
    _this.handleResize = function () {
      _this.setState({
        shouldRefresh: true
      });
    };
    _this.hasImage = function () {
      return _this.imgEl && (_this.state.loadedImgEl || testSvg(_this.imgEl)) && window.getComputedStyle(_this.imgEl).display !== 'none';
    };
    _this.zoom = function () {
      var _this$refDialog$curre, _this$refDialog$curre2, _this$refModalImg$cur, _this$refModalImg$cur2;
      _this.bodyScrollDisable();
      (_this$refDialog$curre = _this.refDialog.current) === null || _this$refDialog$curre === void 0 || (_this$refDialog$curre2 = _this$refDialog$curre.showModal) === null || _this$refDialog$curre2 === void 0 || _this$refDialog$curre2.call(_this$refDialog$curre);
      _this.setState({
        modalState: "LOADING"
      });
      _this.loadZoomImg();
      window.addEventListener('touchstart', _this.handleTouchStart, {
        passive: true
      });
      window.addEventListener('touchmove', _this.handleTouchMove, {
        passive: true
      });
      window.addEventListener('touchend', _this.handleTouchEnd, {
        passive: true
      });
      window.addEventListener('touchcancel', _this.handleTouchCancel, {
        passive: true
      });
      document.addEventListener('keydown', _this.handleKeyDown, true);
      (_this$refModalImg$cur = _this.refModalImg.current) === null || _this$refModalImg$cur === void 0 || (_this$refModalImg$cur2 = _this$refModalImg$cur.addEventListener) === null || _this$refModalImg$cur2 === void 0 || _this$refModalImg$cur2.call(_this$refModalImg$cur, 'transitionend', _this.handleZoomEnd, {
        once: true
      });
    };
    _this.handleZoomEnd = function () {
      setTimeout(function () {
        _this.setState({
          modalState: "LOADED"
        });
        window.addEventListener('resize', _this.handleResize, {
          passive: true
        });
        window.addEventListener('wheel', _this.handleWheel, {
          passive: true
        });
      }, 0);
    };
    _this.unzoom = function () {
      var _this$refModalImg$cur3, _this$refModalImg$cur4;
      _this.setState({
        modalState: "UNLOADING"
      });
      window.removeEventListener('wheel', _this.handleWheel);
      window.removeEventListener('touchstart', _this.handleTouchStart);
      window.removeEventListener('touchmove', _this.handleTouchMove);
      window.removeEventListener('touchend', _this.handleTouchEnd);
      window.removeEventListener('touchcancel', _this.handleTouchCancel);
      document.removeEventListener('keydown', _this.handleKeyDown, true);
      (_this$refModalImg$cur3 = _this.refModalImg.current) === null || _this$refModalImg$cur3 === void 0 || (_this$refModalImg$cur4 = _this$refModalImg$cur3.addEventListener) === null || _this$refModalImg$cur4 === void 0 || _this$refModalImg$cur4.call(_this$refModalImg$cur3, 'transitionend', _this.handleUnzoomEnd, {
        once: true
      });
    };
    _this.handleUnzoomEnd = function () {
      setTimeout(function () {
        window.removeEventListener('resize', _this.handleResize);
        _this.setState({
          shouldRefresh: false,
          modalState: "UNLOADED"
        }, function () {
          var _this$refDialog$curre3, _this$refDialog$curre4;
          (_this$refDialog$curre3 = _this.refDialog.current) === null || _this$refDialog$curre3 === void 0 || (_this$refDialog$curre4 = _this$refDialog$curre3.close) === null || _this$refDialog$curre4 === void 0 || _this$refDialog$curre4.call(_this$refDialog$curre3);
          _this.bodyScrollEnable();
        });
      }, 0);
    };
    _this.bodyScrollDisable = function () {
      _this.prevBodyAttrs = {
        overflow: document.body.style.overflow,
        width: document.body.style.width
      };
      var clientWidth = document.body.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.width = "".concat(clientWidth, "px");
    };
    _this.bodyScrollEnable = function () {
      document.body.style.width = _this.prevBodyAttrs.width;
      document.body.style.overflow = _this.prevBodyAttrs.overflow;
      _this.prevBodyAttrs = defaultBodyAttrs;
    };
    _this.loadZoomImg = function () {
      var _this3 = _this,
        zoomImg = _this3.props.zoomImg;
      var zoomImgSrc = zoomImg === null || zoomImg === void 0 ? void 0 : zoomImg.src;
      if (zoomImgSrc) {
        var _zoomImg$sizes, _zoomImg$srcSet;
        var img = new Image();
        img.sizes = (_zoomImg$sizes = zoomImg === null || zoomImg === void 0 ? void 0 : zoomImg.sizes) !== null && _zoomImg$sizes !== void 0 ? _zoomImg$sizes : '';
        img.srcset = (_zoomImg$srcSet = zoomImg === null || zoomImg === void 0 ? void 0 : zoomImg.srcSet) !== null && _zoomImg$srcSet !== void 0 ? _zoomImg$srcSet : '';
        img.src = zoomImgSrc;
        var setLoaded = function setLoaded() {
          _this.setState({
            isZoomImgLoaded: true
          });
        };
        img.decode().then(setLoaded).catch(function () {
          if (testImgLoaded(img)) {
            setLoaded();
            return;
          }
          img.onload = setLoaded;
        });
      }
    };
    _this.UNSAFE_handleSvg = function () {
      var _this4 = _this,
        imgEl = _this4.imgEl,
        refModalImg = _this4.refModalImg,
        styleModalImg = _this4.styleModalImg;
      if (testSvg(imgEl)) {
        var _refModalImg$current, _refModalImg$current$, _refModalImg$current2, _refModalImg$current3;
        var svgEl = imgEl.cloneNode(true);
        adjustSvgIDs(svgEl);
        svgEl.style.width = "".concat(styleModalImg.width || 0, "px");
        svgEl.style.height = "".concat(styleModalImg.height || 0, "px");
        svgEl.addEventListener('click', _this.handleUnzoom);
        (_refModalImg$current = refModalImg.current) === null || _refModalImg$current === void 0 || (_refModalImg$current = _refModalImg$current.firstChild) === null || _refModalImg$current === void 0 || (_refModalImg$current$ = _refModalImg$current.remove) === null || _refModalImg$current$ === void 0 || _refModalImg$current$.call(_refModalImg$current);
        (_refModalImg$current2 = refModalImg.current) === null || _refModalImg$current2 === void 0 || (_refModalImg$current3 = _refModalImg$current2.appendChild) === null || _refModalImg$current3 === void 0 || _refModalImg$current3.call(_refModalImg$current2, svgEl);
      }
    };
    return _this;
  }
  _inherits(ControlledBase, _React$Component);
  return _createClass(ControlledBase, [{
    key: "render",
    value: function render() {
      var handleDialogCancel = this.handleDialogCancel,
        handleDialogClick = this.handleDialogClick,
        handleUnzoom = this.handleUnzoom,
        handleZoom = this.handleZoom,
        imgEl = this.imgEl,
        _this$props3 = this.props,
        a11yNameButtonUnzoom = _this$props3.a11yNameButtonUnzoom,
        a11yNameButtonZoom = _this$props3.a11yNameButtonZoom,
        children = _this$props3.children,
        classDialog = _this$props3.classDialog,
        IconUnzoom = _this$props3.IconUnzoom,
        IconZoom = _this$props3.IconZoom,
        isZoomed = _this$props3.isZoomed,
        WrapElement = _this$props3.wrapElement,
        ZoomContent = _this$props3.ZoomContent,
        zoomImg = _this$props3.zoomImg,
        zoomMargin = _this$props3.zoomMargin,
        refContent = this.refContent,
        refDialog = this.refDialog,
        refModalContent = this.refModalContent,
        refModalImg = this.refModalImg,
        refWrap = this.refWrap,
        _this$state = this.state,
        id = _this$state.id,
        isZoomImgLoaded = _this$state.isZoomImgLoaded,
        loadedImgEl = _this$state.loadedImgEl,
        modalState = _this$state.modalState,
        shouldRefresh = _this$state.shouldRefresh;
      var idModal = "rmiz-modal-".concat(id);
      var idModalImg = "rmiz-modal-img-".concat(id);
      var isDiv = testDiv(imgEl);
      var isImg = testImg(imgEl);
      var isSvg = testSvg(imgEl);
      var imgAlt = getImgAlt(imgEl);
      var imgSrc = getImgSrc(imgEl);
      var imgSizes = isImg ? imgEl.sizes : undefined;
      var imgSrcSet = isImg ? imgEl.srcset : undefined;
      var hasZoomImg = !!(zoomImg !== null && zoomImg !== void 0 && zoomImg.src);
      var hasImage = this.hasImage();
      var labelBtnZoom = imgAlt ? "".concat(a11yNameButtonZoom, ": ").concat(imgAlt) : a11yNameButtonZoom;
      var isModalActive = modalState === "LOADING" || modalState === "LOADED";
      var dataContentState = hasImage ? 'found' : 'not-found';
      var dataOverlayState = modalState === "UNLOADED" || modalState === "UNLOADING" ? 'hidden' : 'visible';
      var styleContent = {
        visibility: modalState === "UNLOADED" ? 'visible' : 'hidden'
      };
      var styleGhost = getStyleGhost(imgEl);
      this.styleModalImg = hasImage ? getStyleModalImg({
        hasZoomImg: hasZoomImg,
        imgSrc: imgSrc,
        isSvg: isSvg,
        isZoomed: isZoomed && isModalActive,
        loadedImgEl: loadedImgEl,
        offset: zoomMargin,
        shouldRefresh: shouldRefresh,
        targetEl: imgEl
      }) : {};
      var modalContent = null;
      if (hasImage) {
        var modalImg = isImg || isDiv ? React.createElement("img", _objectSpread(_objectSpread({
          alt: imgAlt,
          sizes: imgSizes,
          src: imgSrc,
          srcSet: imgSrcSet
        }, isZoomImgLoaded && modalState === "LOADED" ? zoomImg : {}), {}, {
          "data-rmiz-modal-img": "",
          height: this.styleModalImg.height || undefined,
          id: idModalImg,
          ref: refModalImg,
          style: this.styleModalImg,
          width: this.styleModalImg.width || undefined
        })) : isSvg ? React.createElement("div", {
          "data-rmiz-modal-img": true,
          ref: refModalImg,
          style: this.styleModalImg
        }) : null;
        var modalBtnUnzoom = React.createElement("button", {
          "aria-label": a11yNameButtonUnzoom,
          "data-rmiz-btn-unzoom": "",
          onClick: handleUnzoom,
          type: "button"
        }, React.createElement(IconUnzoom, null));
        modalContent = ZoomContent ? React.createElement(ZoomContent, {
          buttonUnzoom: modalBtnUnzoom,
          modalState: modalState,
          img: modalImg,
          onUnzoom: handleUnzoom
        }) : React.createElement(React.Fragment, null, modalImg, modalBtnUnzoom);
      }
      return React.createElement(WrapElement, {
        "aria-owns": idModal,
        "data-rmiz": "",
        ref: refWrap
      }, React.createElement(WrapElement, {
        "data-rmiz-content": dataContentState,
        ref: refContent,
        style: styleContent
      }, children), hasImage && React.createElement(WrapElement, {
        "data-rmiz-ghost": "",
        style: styleGhost
      }, React.createElement("button", {
        "aria-label": labelBtnZoom,
        "data-rmiz-btn-zoom": "",
        onClick: handleZoom,
        type: "button"
      }, React.createElement(IconZoom, null))), hasImage && ReactDOM.createPortal(React.createElement("dialog", {
        "aria-labelledby": idModalImg,
        "aria-modal": "true",
        className: classDialog,
        "data-rmiz-modal": "",
        id: idModal,
        onClick: handleDialogClick,
        onClose: handleUnzoom,
        onCancel: handleDialogCancel,
        ref: refDialog,
        role: "dialog"
      }, React.createElement("div", {
        "data-rmiz-modal-overlay": dataOverlayState
      }), React.createElement("div", {
        "data-rmiz-modal-content": "",
        ref: refModalContent
      }, modalContent)), this.getDialogContainer()));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setId();
      this.setAndTrackImg();
      this.handleImgLoad();
      this.UNSAFE_handleSvg();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$changeObserver2, _this$changeObserver3, _this$imgElObserver, _this$imgElObserver$d, _this$imgEl3, _this$imgEl3$removeEv, _this$imgEl4, _this$imgEl4$removeEv, _this$refModalImg$cur5, _this$refModalImg$cur6, _this$refModalImg$cur7, _this$refModalImg$cur8;
      if (this.state.modalState !== "UNLOADED") {
        this.bodyScrollEnable();
      }
      (_this$changeObserver2 = this.changeObserver) === null || _this$changeObserver2 === void 0 || (_this$changeObserver3 = _this$changeObserver2.disconnect) === null || _this$changeObserver3 === void 0 || _this$changeObserver3.call(_this$changeObserver2);
      (_this$imgElObserver = this.imgElObserver) === null || _this$imgElObserver === void 0 || (_this$imgElObserver$d = _this$imgElObserver.disconnect) === null || _this$imgElObserver$d === void 0 || _this$imgElObserver$d.call(_this$imgElObserver);
      (_this$imgEl3 = this.imgEl) === null || _this$imgEl3 === void 0 || (_this$imgEl3$removeEv = _this$imgEl3.removeEventListener) === null || _this$imgEl3$removeEv === void 0 || _this$imgEl3$removeEv.call(_this$imgEl3, 'load', this.handleImgLoad);
      (_this$imgEl4 = this.imgEl) === null || _this$imgEl4 === void 0 || (_this$imgEl4$removeEv = _this$imgEl4.removeEventListener) === null || _this$imgEl4$removeEv === void 0 || _this$imgEl4$removeEv.call(_this$imgEl4, 'click', this.handleZoom);
      (_this$refModalImg$cur5 = this.refModalImg.current) === null || _this$refModalImg$cur5 === void 0 || (_this$refModalImg$cur6 = _this$refModalImg$cur5.removeEventListener) === null || _this$refModalImg$cur6 === void 0 || _this$refModalImg$cur6.call(_this$refModalImg$cur5, 'transitionend', this.handleZoomEnd);
      (_this$refModalImg$cur7 = this.refModalImg.current) === null || _this$refModalImg$cur7 === void 0 || (_this$refModalImg$cur8 = _this$refModalImg$cur7.removeEventListener) === null || _this$refModalImg$cur8 === void 0 || _this$refModalImg$cur8.call(_this$refModalImg$cur7, 'transitionend', this.handleUnzoomEnd);
      window.removeEventListener('wheel', this.handleWheel);
      window.removeEventListener('touchstart', this.handleTouchStart);
      window.removeEventListener('touchmove', this.handleTouchMove);
      window.removeEventListener('touchend', this.handleTouchEnd);
      window.removeEventListener('touchcancel', this.handleTouchCancel);
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('keydown', this.handleKeyDown, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.UNSAFE_handleSvg();
      this.handleIfZoomChanged(prevProps.isZoomed);
    }
  }]);
}(React.Component);
ControlledBase.defaultProps = {
  a11yNameButtonUnzoom: 'Minimize image',
  a11yNameButtonZoom: 'Expand image',
  canSwipeToUnzoom: true,
  IconUnzoom: ICompress,
  IconZoom: IEnlarge,
  swipeToUnzoomThreshold: 10,
  wrapElement: 'div',
  zoomMargin: 0
};
function Uncontrolled(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isZoomed = _React$useState2[0],
    setIsZoomed = _React$useState2[1];
  return React.createElement(Controlled, _objectSpread(_objectSpread({}, props), {}, {
    isZoomed: isZoomed,
    onZoomChange: setIsZoomed
  }));
}
export { Controlled, Uncontrolled as default };